import React from 'react';
import Icon from './Icons';

/**
 * Bento-style stat tile for profile/dashboard grids.
 * tone controls the value color: 'accent' | 'success' | 'info' | 'warning' | 'default'
 */
const toneColor = {
  default: 'text-text-primary',
  accent: 'text-accent',
  success: 'text-success',
  info: 'text-info',
  warning: 'text-warning',
  error: 'text-error',
};

const StatTile = ({ value, label, icon, tone = 'default', className = '' }) => (
  <div className={`card p-3.5 flex flex-col gap-1 ${className}`}>
    {icon && (
      <span className={`mb-0.5 ${toneColor[tone] || toneColor.default}`}>
        <Icon name={icon} size={18} />
      </span>
    )}
    <div className={`text-2xl font-semibold tracking-tight tabular-nums ${toneColor[tone] || toneColor.default}`}>
      {value}
    </div>
    <div className="text-xs text-text-tertiary">{label}</div>
  </div>
);

export default StatTile;
